export enum VisibilityClass {
	Visible = "visible",
	Hidden = "Hidden",
}
